/* ============================================================
   Polka Tots — pt-reels.js
   Shoppable video reels + story circles (sections/video-reels,
   sections/video-stories) and the one popup player they share.

   Every section renders its cards server-side and a JSON list of
   items ({sm, lg, poster, product}); card N opens item N.
   Add to bag goes through theme.js (PT.addToCart / PT.openCart /
   PT.toast), so the cart drawer and count stay in step.
   ============================================================ */
(function () {
  "use strict";
  /* both sections include this file; run it once */
  if (window.PTReels) return;
  var R = window.PTReels = {};

  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }
  function money(cents) {
    if (window.PT && PT.formatMoney) return PT.formatMoney(cents);
    var fmt = (window.PTdata && PTdata.moneyFormat) || "<span class=money>Rs. {{amount}}</span>";
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
  }
  /* let the currency switcher convert prices drawn into the player */
  function reconvert() {
    try { if (window.bucksCC && typeof window.bucksCC.reConvert === "function") window.bucksCC.reConvert(); } catch (e) {}
  }
  function cleanTitle(t) { return String(t || "").replace(/Polka Tots/g, "").trim(); }
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }

  var reduceMotion = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var designMode = !!(window.Shopify && Shopify.designMode);

  var ICON = {
    play: '<svg viewBox="0 0 24 24"><path d="M8 5.6v12.8a1 1 0 0 0 1.5.9l10-6.4a1 1 0 0 0 0-1.8l-10-6.4A1 1 0 0 0 8 5.6z"/></svg>',
    close: '<svg class="ic" viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>',
    left: '<svg class="ic" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>',
    right: '<svg class="ic" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>',
    bag: '<svg class="ic" viewBox="0 0 24 24"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7V5.5a3 3 0 0 1 6 0V7"/></svg>',
    check: '<svg class="ic" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>',
    soundOn: '<svg class="ic" viewBox="0 0 24 24"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><path d="M15.5 9a4.5 4.5 0 0 1 0 6"/><path d="M18 6.5a8 8 0 0 1 0 11"/></svg>',
    soundOff: '<svg class="ic" viewBox="0 0 24 24"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z"/><line x1="16" y1="9.5" x2="21" y2="14.5"/><line x1="21" y1="9.5" x2="16" y2="14.5"/></svg>'
  };

  /* ---------- section data ---------- */
  function feed(root) {
    if (!root._reelFeed) {
      var el = root.querySelector("[data-reels-json]");
      try { root._reelFeed = (JSON.parse(el.textContent).items) || []; } catch (e) { root._reelFeed = []; }
    }
    return root._reelFeed;
  }

  /* ---------- "seen" story rings (per browser) ---------- */
  var SEEN_KEY = "pt_reels_seen";
  function seenList() { var ls = store("localStorage"); try { return JSON.parse((ls && ls.getItem(SEEN_KEY)) || "[]"); } catch (e) { return []; } }
  function seenKey(item) { return String(item.sm || "").split("?")[0].split("/").pop(); }
  function markSeen(item) {
    var k = seenKey(item), a = seenList();
    if (!k || a.indexOf(k) > -1) return;
    a.push(k);
    var ls = store("localStorage");
    try { if (ls) ls.setItem(SEEN_KEY, JSON.stringify(a.slice(-300))); } catch (e) {}
  }
  function paintSeen(root) {
    if (!root.hasAttribute("data-stories")) return;
    var a = seenList(), items = feed(root);
    $$("[data-reel-open]", root).forEach(function (el) {
      var it = items[+el.getAttribute("data-reel-open")];
      if (it) el.classList.toggle("is-seen", a.indexOf(seenKey(it)) > -1);
    });
  }

  /* ============================================================
     PREVIEWS — muted, only while on screen, src attached lazily
     so nothing downloads for videos nobody scrolls to.
     ============================================================ */
  var popupOpen = false;
  var previewIO = ("IntersectionObserver" in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target._reelVisible = e.isIntersecting;
      if (e.isIntersecting) playPreview(e.target); else pausePreview(e.target);
    });
  }, { threshold: 0.4 }) : null;

  function playPreview(v) {
    if (popupOpen) return;
    if (!v.getAttribute("src") && v.getAttribute("data-src")) v.setAttribute("src", v.getAttribute("data-src"));
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pausePreview(v) { if (!v.paused) v.pause(); }
  function pauseAllPreviews() { $$("[data-reel-preview]").forEach(pausePreview); }
  function resumePreviews() { $$("[data-reel-preview]").forEach(function (v) { if (v._reelVisible) playPreview(v); }); }

  function initRoot(root) {
    if (root._reelInit) return;
    root._reelInit = true;
    feed(root);
    paintSeen(root);
    var auto = root.getAttribute("data-autoplay") !== "false" && !saveData && !reduceMotion && previewIO;
    $$("[data-reel-preview]", root).forEach(function (v) {
      v.muted = true;
      if (auto) previewIO.observe(v);
    });
  }
  /* ============================================================
     PDP CIRCLES — sections/product-main leaves an empty
     [data-pdp-stories] slot under the buy buttons. It is filled from
     the page's Video reels section, whose list already leads with this
     product's videos, and from then on behaves like a stories row.
     ============================================================ */
  /* the page's Video reels section — the shared list the PDP circles and the
     floating reel continue into */
  function reelsSource() { return document.querySelector("[data-reels]:not([data-stories]):not([data-float])"); }

  /* this product's own videos, from the floating reel's JSON (custom.reel_videos) */
  function ownItems() {
    var f = document.querySelector("[data-float] [data-reels-json]");
    if (!f) return [];
    try { return JSON.parse(f.textContent).items || []; } catch (e) { return []; }
  }

  /* a list followed by another, without repeating a video */
  function mergeItems(first, rest) {
    var seen = {};
    return first.concat(rest).filter(function (it) { if (!it || !it.sm || seen[it.sm]) return false; seen[it.sm] = true; return true; });
  }

  function fillSlots() {
    var src = reelsSource();
    $$("[data-pdp-stories]").forEach(function (slot) {
      if (slot._reelInit && slot._reelSrc === src) return;
      if (previewIO) $$("[data-reel-preview]", slot).forEach(function (v) { previewIO.unobserve(v); });
      var items = mergeItems(ownItems(), src ? feed(src) : []).slice(0, parseInt(slot.getAttribute("data-max"), 10) || 8);
      slot._reelSrc = src;
      slot._reelInit = false;
      if (!items.length) { slot.hidden = true; slot.innerHTML = ""; return; }
      slot._reelFeed = items;
      slot.setAttribute("data-reels", "");
      slot.setAttribute("data-stories", "");
      slot.setAttribute("data-advance", "true");
      slot.setAttribute("data-autoplay", (src && src.getAttribute("data-autoplay")) || "true");
      slot.setAttribute("data-atc-label", (src && src.getAttribute("data-atc-label")) || "Add to cart");
      var label = slot.getAttribute("data-label");
      slot.innerHTML = (label ? '<div class="pdp-stories__h">' + ICON.play + "<span>" + esc(label) + "</span></div>" : "") +
        '<div class="st__track">' + items.map(function (it, i) {
          return '<button type="button" class="st-item" data-reel-open="' + i + '" aria-label="Watch ' + esc(it.product ? cleanTitle(it.product.title) : "video") + '">' +
            '<span class="st-ring"><span class="st-circle"><video data-reel-preview data-src="' + esc(it.sm) + '"' + (it.poster ? ' poster="' + esc(it.poster) + '"' : "") +
            ' muted playsinline loop preload="none" disablepictureinpicture aria-hidden="true" tabindex="-1"></video></span></span></button>';
        }).join("") + "</div>";
      slot.hidden = false;
      initRoot(slot);
    });
  }

  /* ============================================================
     FLOATING REEL — sections/video-float. Plays this product's video
     muted in the corner; opens the player on its videos followed by
     the page's other reels. Closing hides it for this product for
     the rest of the visit.
     ============================================================ */
  var FLOAT_KEY = "pt_float_closed:";
  function floatClosed(root) {
    var ss = store("sessionStorage");
    try { return !!(ss && ss.getItem(FLOAT_KEY + root.getAttribute("data-product-id"))); } catch (e) { return false; }
  }

  function initFloats() {
    $$("[data-float]").forEach(function (root) {
      if (root._floatInit) return;
      root._floatInit = true;
      var src = reelsSource();
      root._reelFeed = mergeItems(ownItems(), src ? feed(src) : []);
      if (floatClosed(root) && !designMode) return;
      var delay = parseInt(root.getAttribute("data-delay"), 10) || 0;
      var show = function () {
        setTimeout(function () {
          if (floatClosed(root) && !designMode) return;
          root.hidden = false;
          void root.offsetWidth;
          root.classList.add("is-in");
          initRoot(root);
        }, delay);
      };
      /* after the page has loaded, so the reel never competes with the product photos */
      if (document.readyState === "complete") show(); else window.addEventListener("load", show, { once: true });
    });
  }

  function closeFloat(root) {
    var v = root.querySelector("[data-reel-preview]");
    if (v) { if (previewIO) previewIO.unobserve(v); v._reelVisible = false; v.pause(); v.removeAttribute("src"); v.load(); }
    root.classList.remove("is-in");
    root.classList.add("is-out");
    setTimeout(function () { root.hidden = true; }, 400);
    var ss = store("sessionStorage");
    try { if (ss) ss.setItem(FLOAT_KEY + root.getAttribute("data-product-id"), "1"); } catch (e) {}
  }

  function initAll(scope) { fillSlots(); initFloats(); $$("[data-reels]:not([data-float])", scope).forEach(initRoot); }
  R.init = initAll;

  /* ============================================================
     POPUP PLAYER
     ============================================================ */
  var P = null;
  var S = { open: false, root: null, items: [], i: 0, muted: false, pushed: false, advance: false,
            atcLabel: "Add to cart", product: null, chosen: [], lastFocus: null, lastSwipe: 0, lastWheel: 0 };

  function build() {
    var el = document.createElement("div");
    el.className = "rlp";
    el.hidden = true;
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", "Shoppable videos");
    el.innerHTML =
      '<div class="rlp__bg" data-rlp-close></div>' +
      '<button type="button" class="rlp__x" data-rlp-close aria-label="Close videos">' + ICON.close + '</button>' +
      '<div class="rlp__stage">' +
        '<button type="button" class="rlp__ghost" data-rlp-prev tabindex="-1" aria-hidden="true"><img alt=""></button>' +
        '<button type="button" class="rlp__nav" data-rlp-prev aria-label="Previous video">' + ICON.left + '</button>' +
        '<div class="rlp__player">' +
          '<video class="rlp__vid" playsinline preload="auto" disablepictureinpicture></video>' +
          '<div class="rlp__shade"></div>' +
          '<button type="button" class="rlp__tap" data-rlp-toggle aria-label="Pause video"></button>' +
          '<div class="rlp__bar" aria-hidden="true"><i></i></div>' +
          '<div class="rlp__top"><span class="rlp__count" aria-live="polite"></span>' +
            '<button type="button" class="rlp__mute" data-rlp-mute></button></div>' +
          '<span class="rlp__state" aria-hidden="true">' + ICON.play + '</span>' +
          '<span class="rlp__spin" aria-hidden="true"></span>' +
          '<div class="rlp__prod" hidden></div>' +
        '</div>' +
        '<button type="button" class="rlp__nav" data-rlp-next aria-label="Next video">' + ICON.right + '</button>' +
        '<button type="button" class="rlp__ghost" data-rlp-next tabindex="-1" aria-hidden="true"><img alt=""></button>' +
      '</div>';
    document.body.appendChild(el);

    var ghosts = el.querySelectorAll(".rlp__ghost"), navs = el.querySelectorAll(".rlp__nav");
    P = {
      el: el,
      stage: el.querySelector(".rlp__stage"),
      player: el.querySelector(".rlp__player"),
      vid: el.querySelector(".rlp__vid"),
      bar: el.querySelector(".rlp__bar i"),
      count: el.querySelector(".rlp__count"),
      mute: el.querySelector("[data-rlp-mute]"),
      tap: el.querySelector("[data-rlp-toggle]"),
      prod: el.querySelector(".rlp__prod"),
      close: el.querySelector(".rlp__x"),
      ghostPrev: ghosts[0], ghostNext: ghosts[1],
      navPrev: navs[0], navNext: navs[1]
    };

    var v = P.vid;
    v.addEventListener("timeupdate", function () {
      if (v.duration) P.bar.style.transform = "scaleX(" + Math.min(1, v.currentTime / v.duration) + ")";
    });
    v.addEventListener("waiting", function () { el.classList.add("is-waiting"); });
    v.addEventListener("playing", function () { el.classList.remove("is-waiting", "is-paused"); P.tap.setAttribute("aria-label", "Pause video"); });
    v.addEventListener("pause", function () { if (S.open && !v.ended) { el.classList.add("is-paused"); P.tap.setAttribute("aria-label", "Play video"); } });
    v.addEventListener("ended", function () {
      if (S.i < S.items.length - 1) go(1);
      else { v.currentTime = 0; play(); }
    });

    el.addEventListener("click", onPopupClick);
    /* touching the product panel means someone is shopping this video —
       stop story auto-advance so the size picker can't slide away mid-choice */
    P.prod.addEventListener("pointerdown", hold);
    P.prod.addEventListener("focusin", hold);

    /* swipe: up / left = next, down / right = previous. Touches that start on
       the product panel belong to its size chips, not to navigation. */
    var t0 = null;
    P.stage.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1 || e.target.closest(".rlp__prod")) { t0 = null; return; }
      t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    P.stage.addEventListener("touchend", function (e) {
      if (!t0) return;
      var dx = e.changedTouches[0].clientX - t0.x, dy = e.changedTouches[0].clientY - t0.y;
      t0 = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 50) return;
      S.lastSwipe = Date.now();
      if (Math.abs(dy) > Math.abs(dx)) go(dy < 0 ? 1 : -1); else go(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* trackpad / mouse wheel steps one video per gesture */
    P.stage.addEventListener("wheel", function (e) {
      if (e.target.closest(".rlp__prod")) return;
      e.preventDefault();
      var now = Date.now();
      if (Math.abs(e.deltaY) < 20 || now - S.lastWheel < 650) return;
      S.lastWheel = now;
      go(e.deltaY > 0 ? 1 : -1);
    }, { passive: false });
  }

  function onPopupClick(e) {
    var t = e.target;
    if (t.closest("[data-rlp-close]")) { close(); return; }
    if (t.closest("[data-rlp-prev]")) { go(-1); return; }
    if (t.closest("[data-rlp-next]")) { go(1); return; }
    if (t.closest("[data-rlp-mute]")) { setMuted(!S.muted); return; }
    if (t.closest("[data-rlp-toggle]")) {
      if (Date.now() - S.lastSwipe < 400) return;
      if (P.vid.paused) play(); else P.vid.pause();
      return;
    }
    var chip = t.closest("[data-rlp-opt]");
    if (chip) { choose(+chip.getAttribute("data-rlp-opt"), chip.getAttribute("data-val")); return; }
    if (t.closest("[data-rlp-atc]")) { onAtc(); return; }
  }

  function hold() { if (P) P.vid.loop = true; }

  function play() {
    var v = P.vid;
    v.muted = S.muted;
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      /* opening is a tap, so sound is normally allowed — if a browser still
         refuses, fall back to muted rather than showing a stalled video */
      if (err && err.name === "NotAllowedError" && !v.muted) {
        setMuted(true);
        v.play().catch(function () { P.el.classList.add("is-paused"); });
      }
    });
  }

  function setMuted(m) {
    S.muted = m;
    if (P) {
      P.vid.muted = m;
      P.mute.innerHTML = m ? ICON.soundOff : ICON.soundOn;
      P.mute.setAttribute("aria-label", m ? "Unmute" : "Mute");
    }
    var ss = store("sessionStorage");
    try { if (ss) ss.setItem("pt_reels_muted", m ? "1" : "0"); } catch (e) {}
  }

  function open(root, i, nudge) {
    var items = feed(root);
    if (!items[i]) return;
    if (!P) build();
    S.root = root;
    S.items = items;
    S.advance = root.getAttribute("data-advance") === "true";
    S.atcLabel = root.getAttribute("data-atc-label") || "Add to cart";
    var ss = store("sessionStorage");
    var pref = null;
    try { pref = ss && ss.getItem("pt_reels_muted"); } catch (e) {}
    setMuted(pref === "1");

    if (!S.open) {
      S.open = true;
      popupOpen = true;
      S.lastFocus = document.activeElement;
      pauseAllPreviews();
      /* last in <body>, so it stacks above app widgets that share its max z-index */
      if (P.el !== document.body.lastElementChild) document.body.appendChild(P.el);
      P.el.hidden = false;
      void P.el.offsetWidth;
      P.el.classList.add("open");
      lockScroll();
      /* one history entry so the phone's back button closes the player
         instead of leaving the page */
      if (!designMode && !S.pushed) {
        try { history.pushState({ ptReels: 1 }, ""); S.pushed = true; } catch (e) {}
      }
    }
    show(i, 0);
    P.close.focus({ preventScroll: true });
    if (nudge) setTimeout(nudgeOptions, 350);
  }

  function close(fromHistory) {
    if (!S.open) return;
    S.open = false;
    popupOpen = false;
    var v = P.vid;
    v.pause();
    v.removeAttribute("src");
    v.load();
    P.el.classList.remove("open", "is-paused", "is-waiting");
    setTimeout(function () { if (!S.open) P.el.hidden = true; }, 300);
    unlockScroll();
    if (S.pushed) {
      S.pushed = false;
      if (!fromHistory) history.back();
    }
    if (S.root) paintSeen(S.root);
    resumePreviews();
    if (S.lastFocus && S.lastFocus.focus) S.lastFocus.focus({ preventScroll: true });
  }
  R.close = close;

  window.addEventListener("popstate", function () {
    if (S.open) { S.pushed = false; close(true); }
  });
  /* leaving through a product link and coming back restores the page from
     the back/forward cache — with the player still open. Close it. */
  window.addEventListener("pageshow", function (e) { if (e.persisted && S.open) close(); });

  function go(d) {
    var n = S.i + d;
    if (n < 0 || n >= S.items.length) return;
    show(n, d);
  }

  function show(i, dir) {
    S.i = i;
    var it = S.items[i], v = P.vid;
    P.player.classList.remove("in-next", "in-prev", "in-fade");
    void P.player.offsetWidth;
    if (!reduceMotion) P.player.classList.add(dir > 0 ? "in-next" : dir < 0 ? "in-prev" : "in-fade");

    P.el.classList.remove("is-paused");
    P.el.classList.add("is-waiting");
    P.bar.style.transform = "scaleX(0)";
    v.loop = !S.advance; /* hold() may have set it for the previous video */
    if (it.poster) v.setAttribute("poster", it.poster); else v.removeAttribute("poster");
    v.setAttribute("src", it.lg || it.sm);
    play();

    var total = S.items.length;
    P.count.textContent = (i + 1) + " / " + total;
    P.navPrev.disabled = i === 0;
    P.navNext.disabled = i === total - 1;
    ghost(P.ghostPrev, S.items[i - 1]);
    ghost(P.ghostNext, S.items[i + 1]);
    renderProduct(it.product);
    if (S.root && S.root.hasAttribute("data-stories")) markSeen(it);

    /* warm the next poster so the swipe lands on a picture, not black */
    var nx = S.items[i + 1];
    if (nx && nx.poster) { var im = new Image(); im.src = nx.poster; }
  }

  function ghost(btn, it) {
    var img = btn.querySelector("img");
    if (it && it.poster) { img.src = it.poster; btn.classList.remove("is-empty"); }
    else { img.removeAttribute("src"); btn.classList.add("is-empty"); }
  }

  /* ---------- product panel: size picker + add to bag ---------- */
  function values(p, oi) {
    var out = [];
    p.variants.forEach(function (v) { if (out.indexOf(v.o[oi]) < 0) out.push(v.o[oi]); });
    return out;
  }

  function renderProduct(p) {
    S.product = p || null;
    if (!p) { P.prod.hidden = true; P.prod.innerHTML = ""; return; }
    P.prod.hidden = false;
    S.chosen = p.options.map(function (_, oi) { var vals = values(p, oi); return vals.length === 1 ? vals[0] : null; });

    var opts = p.options.map(function (name, oi) {
      var vals = values(p, oi);
      if (vals.length < 2) return "";
      return '<div class="rlp__opt" data-rlp-optrow="' + oi + '"><span class="rlp__optl">' + esc(name) + '</span>' +
        '<div class="rlp__chips" role="group" aria-label="' + esc(name) + '">' +
        vals.map(function (val) {
          return '<button type="button" class="rlp__chip" data-rlp-opt="' + oi + '" data-val="' + esc(val) + '" aria-pressed="false">' + esc(val) + '</button>';
        }).join("") + '</div></div>';
    }).join("");

    P.prod.innerHTML =
      '<div class="rlp__card">' +
        '<a class="rlp__pi" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="52" height="64">' : "") + '</a>' +
        '<div class="rlp__pm"><a class="rlp__pt" href="' + esc(p.url) + '">' + esc(cleanTitle(p.title)) + '</a>' +
        '<div class="rlp__pp" data-rlp-price></div></div>' +
      '</div>' + opts +
      '<button type="button" class="rlp__atc" data-rlp-atc></button>';
    sync();
  }

  function variant() {
    var p = S.product;
    if (!p || S.chosen.some(function (c) { return c == null; })) return null;
    for (var k = 0; k < p.variants.length; k++) {
      var v = p.variants[k], hit = true;
      for (var j = 0; j < S.chosen.length; j++) if (v.o[j] !== S.chosen[j]) { hit = false; break; }
      if (hit) return v;
    }
    return null;
  }

  /* a value is sold out when no in-stock variant has it together with the
     other values already picked */
  function valueAvailable(oi, val) {
    return S.product.variants.some(function (v) {
      if (!v.a || v.o[oi] !== val) return false;
      for (var j = 0; j < S.chosen.length; j++) if (j !== oi && S.chosen[j] != null && v.o[j] !== S.chosen[j]) return false;
      return true;
    });
  }

  function choose(oi, val) {
    S.chosen[oi] = val;
    var row = P.prod.querySelector('[data-rlp-optrow="' + oi + '"]');
    if (row) row.classList.remove("nudge");
    sync();
  }

  function sync() {
    var p = S.product, v = variant();
    $$("[data-rlp-opt]", P.prod).forEach(function (c) {
      var oi = +c.getAttribute("data-rlp-opt"), val = c.getAttribute("data-val");
      c.setAttribute("aria-pressed", S.chosen[oi] === val ? "true" : "false");
      c.classList.toggle("oos", !valueAvailable(oi, val));
    });

    var price = v ? v.p : p.price, compare = v ? v.c : p.compare;
    var off = compare > price ? Math.round((compare - price) / compare * 100) : 0;
    P.prod.querySelector("[data-rlp-price]").innerHTML =
      "<b>" + money(price) + "</b>" + (off ? "<del>" + money(compare) + "</del><em>" + off + "% off</em>" : "");
    reconvert();

    var b = P.prod.querySelector("[data-rlp-atc]");
    b.disabled = false;
    if (!p.available) { b.dataset.mode = "soldout"; b.disabled = true; b.textContent = "Sold out"; return; }
    if (!v) {
      var missing = p.options[S.chosen.indexOf(null)] || "size";
      b.dataset.mode = "pick";
      b.innerHTML = ICON.bag + "<span>Select " + esc(String(missing).toLowerCase()) + "</span>";
      return;
    }
    if (!v.a) { b.dataset.mode = "soldout"; b.disabled = true; b.textContent = "Sold out in this size"; return; }
    b.dataset.mode = "add";
    b.innerHTML = ICON.bag + "<span>" + esc(S.atcLabel) + "</span>";
  }

  function nudgeOptions() {
    var oi = S.chosen.indexOf(null);
    var row = oi > -1 && P.prod.querySelector('[data-rlp-optrow="' + oi + '"]');
    if (!row) return;
    row.classList.remove("nudge");
    void row.offsetWidth;
    row.classList.add("nudge");
    var first = row.querySelector(".rlp__chip:not(.oos)") || row.querySelector(".rlp__chip");
    if (first) first.focus({ preventScroll: true });
  }

  function onAtc() {
    var b = P.prod.querySelector("[data-rlp-atc]");
    var mode = b.dataset.mode;
    if (mode === "pick") { nudgeOptions(); return; }
    if (mode === "view") { close(); if (window.PT && PT.openCart) PT.openCart(); return; }
    var v = variant();
    if (mode !== "add" || !v) return;
    if (!(window.PT && PT.addToCart)) { window.location.href = S.product.url; return; }
    b.disabled = true;
    PT.addToCart(v.id, 1).then(function () {
      if (PT.toast) PT.toast("Added to bag");
      b.disabled = false;
      b.dataset.mode = "view";
      b.innerHTML = ICON.check + "<span>Added · View bag</span>";
    }).catch(function () { b.disabled = false; });
  }

  /* ---------- scroll lock (same contract as theme.js overlays) ---------- */
  function lockScroll() { document.documentElement.classList.add("no-scroll"); document.body.style.overflow = "hidden"; }
  function unlockScroll() {
    if (document.querySelector("[data-cart-drawer].open, [data-mnav].open, [data-search-sheet].open, [data-qv].open")) return;
    document.documentElement.classList.remove("no-scroll");
    document.body.style.overflow = "";
  }

  /* ---------- page-level wiring ---------- */
  document.addEventListener("click", function (e) {
    var fx = e.target.closest("[data-float-close]");
    if (fx) { e.preventDefault(); closeFloat(fx.closest("[data-float]")); return; }
    var o = e.target.closest("[data-reel-open]");
    if (o) {
      var root = o.closest("[data-reels]");
      if (root) { e.preventDefault(); open(root, +o.getAttribute("data-reel-open"), false); }
      return;
    }
    var a = e.target.closest("[data-reel-atc]");
    if (a) {
      var r = a.closest("[data-reels]");
      if (!r) return;
      e.preventDefault();
      var idx = +a.getAttribute("data-reel-atc"), it = feed(r)[idx], p = it && it.product;
      if (!p) return;
      /* a single in-stock variant goes straight to the bag, like the product
         grid; anything with sizes opens the player at the size picker */
      var only = p.variants.length === 1 ? p.variants[0] : null;
      if (only && only.a && window.PT && PT.addToCart) {
        a.classList.add("done");
        PT.addToCart(only.id, 1).then(function () {
          if (PT.toast) PT.toast("Added to bag");
          if (PT.openCart) PT.openCart();
        }).catch(function () {}).then(function () { setTimeout(function () { a.classList.remove("done"); }, 1200); });
      } else {
        open(r, idx, true);
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!S.open) return;
    var k = e.key;
    if (k === "Escape") { close(); return; }
    if (k === "ArrowDown" || k === "ArrowRight") { e.preventDefault(); go(1); return; }
    if (k === "ArrowUp" || k === "ArrowLeft") { e.preventDefault(); go(-1); return; }
    if ((k === "m" || k === "M") && !e.ctrlKey && !e.metaKey) { setMuted(!S.muted); return; }
    if (k === "Tab") {
      /* keep focus inside the dialog */
      var f = $$("button:not([disabled]), a[href]", P.el).filter(function (x) { return x.offsetParent !== null && x.tabIndex !== -1; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener("visibilitychange", function () {
    if (document.hidden && S.open && P) P.vid.pause();
  });

  /* theme editor: sections re-render in place */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    if (S.open && S.root && e.target.contains(S.root)) close();
    if (previewIO) $$("[data-reel-preview]", e.target).forEach(function (v) { previewIO.unobserve(v); });
  });
  document.addEventListener("shopify:block:select", function (e) {
    if (e.target.closest && e.target.closest("[data-reels]")) e.target.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(); });
  else initAll();
})();
